const stringDecimalNumberToInteger = (stringNumber) => parseInt(parseFloat(stringNumber), 10);
const scoringParser = ({ sales_attributes = {} } = {}) => {
  if (!sales_attributes || typeof sales_attributes !== 'object') {
    return null;
  }

  const { scoring = '' } = sales_attributes;

  if (!scoring || scoring === '') {
    return null;
  }

  return `${stringDecimalNumberToInteger(scoring)}%`;
};

export default scoringParser;
